/**
 * ROOFTOPS — realism pass for the original 80 m skyline.
 * All logic is shared by the rooftop family: see `rooftopsLayout.ts` (pure
 * layout + contract) and `rooftopsBuild.ts` (merged meshes). Contract bench:
 * `agent/bench-extras-rooftops.mjs`.
 */
export const mapIds = ["rooftops"];
export { buildRooftopExtras as build } from "./rooftopsBuild.js";
